export const USER_TOKEN_KEY = '@userToken';
